import { NgModule, InjectionToken } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrSwiperComponent } from './pr-swiper.component';
import { PrSlideComponent } from './pr-slide/pr-slide.component';
import { SwiperOptions } from 'swiper';

export const APP_SWIPER_CONFIG_TOKEN = new InjectionToken<SwiperOptions>('APP_SWIPER_CONFIG');
export const APP_SWIPER_CONFIG: SwiperOptions = {};

@NgModule({
  declarations: [PrSwiperComponent, PrSlideComponent],
  imports: [CommonModule],
  exports: [PrSwiperComponent, PrSlideComponent],
  providers: [
    {
      provide: APP_SWIPER_CONFIG_TOKEN,
      useValue: APP_SWIPER_CONFIG,
    },
  ],
})
export class PrSwiperModule {}
